module.exports = __webpack_public_path__ + "static/media/img010.914a5539.jpg";